var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"j-radio-group"},_vm._l((_vm.options),function(opt){return _c('j-radio',{key:opt.value,attrs:{"checked":_vm.currentSelected === opt.label},on:{"value":function($event){return _vm.handleToggle($event, opt)}}},[_vm._v("\n    "+_vm._s(opt.label)+"\n  ")])}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56870f5e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/radio-group/radio-group.vue
// module id = EKpd
// module chunks = 1